import React, {Fragment} from "react";
import ListView from "../../../../components/ContentDisplay/ListView";
import ReportStatus from "../reportStatus";
import ReportCard from "../reportCard";
import DeleteModal from "../../../../components/Modal/DeleteModal";
import {useReportTableData} from "./useReportTableData";
import {useReportTableActions} from "./useReportTableActions";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./reportsTable.constants";

const ReportsTable = () => {
  const {modalOpen, toggleModal, handleDelete, handleRowClick, handleActionSelection} =
    useReportTableActions();
  const {reportList} = useReportTableData();
  return (
    <Fragment>
      {modalOpen && (
        <DeleteModal
          header={"Delete Report"}
          modalBody={"Are you sure you want to delete this report ?"}
          onClose={() => toggleModal(false)}
          onDelete={handleDelete}
          open={modalOpen}
        />
      )}
      <div className="mt-2 mt-sm-0">
        <ListView
          listItems={reportList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={PERMS_FOR_ACTIONS}
          customRenderKeys={["status"]}
          customRenderComponent={ReportStatus}
          rowClickable
          onSelectRow={handleRowClick}
          cardContent={ReportCard}
        />
      </div>
    </Fragment>
  );
};

export default ReportsTable;
